var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSourceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 6.45833H8.125V1.625H13.4917C16.525 1.625 18.3333 3.43333 18.3333 6.45833Z",
    fill: "#8E99A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 13.5417C18.2917 16.5167 16.4917 18.2917 13.4917 18.2917H8.125V13.5417H18.3333Z",
    fill: "#8E99A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87484 1.625V18.2917H6.50817C3.47484 18.2917 1.6665 16.4833 1.6665 13.45V6.46667C1.6665 3.43333 3.47484 1.625 6.50817 1.625H6.87484Z",
    fill: "#8E99A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 7.70825H8.125V12.2916H18.3333V7.70825Z",
    fill: "#8E99A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceIcon);
export default __webpack_public_path__ + "static/media/SourceIcon.b7c68e5da8eb64cf214420035f71b03e.svg";
export { ForwardRef as ReactComponent };